// subtotal dropdown
// function ReadCookie() {
//   let newsletterCookie = sessionStorage.getItem("open-newsletter");
//   console.log(newsletterCookie);
//   if (newsletterCookie == null) {
//     jQuery(window).on("load", function () {
//       setTimeout(function () {
//         jQuery("body").addClass("open-newsletter");
//         console.log("window loaded");
//         sessionStorage.setItem("open-newsletter", "Close");
//       }, 1500);
//     });
//   }
// }

jQuery(".btn-mobile-menu").click(function () {
  jQuery("body").toggleClass("open-menu");
});

// ReadCookie();

jQuery(document).ready(function () {
  jQuery(document).on("click", ".selected-li .subtotal-btn ", function (e) {
    e.preventDefault();
    document.querySelector(".panel-group").scrollIntoView({
      behavior: "smooth",
    });
  });

  jQuery(document).on(
    "click",
    ".nav-link modal-btn bag_element a",
    function () {
      jQuery(".filter-sec.bag-sec-sec").show();
    }
  );

  jQuery(document).on("click", ".mobile-right li a", function () {
    jQuery(".filter-sec.bag-sec-sec").show();
  });

  var count1 = $("#cart-count").text();
  if (count1 > 0) {
    jQuery("#image-fill").show();
  } else {
    jQuery("#image-unfill").show();
  }
});

// var slider = jQuery(".home-slider .item");
// jQuery.each(slider, function (i) {
//   var count = i + 1;
//   jQuery(this).attr("id", "0" + count);
// });

// jQuery(document).on("click", ".item", function () {
//   var id = jQuery(this).attr("id");
//   var slider1 = jQuery(".swiper-pagination .swiper-pagination-bullet");
//   jQuery.each(slider1, function (i) {
//     if (id == jQuery(this).text().replace(" ", "")) {
//       jQuery(this).click();
//     }
//   });
// });
jQuery(document).on("click", ".item", function () {
  var id = jQuery(this).attr("key");
  jQuery(document).ready(function () {
    setTimeout(function(){       
    var slider1 = jQuery(".swiper-pagination .swiper-pagination-bullet");
      jQuery.each(slider1, function (i) {
        if (id == jQuery(this).text().replace(" ", "")) {
          jQuery(this).click();
        }
      });
    }, 1000);
  });
});

jQuery(".filter-button").click(function () {
  jQuery("body").addClass("open-newsletter-filter");
});

jQuery(".close-newsletter").click(function () {
  jQuery("body").removeClass("open-newsletter");
  jQuery("body").css("overflow", "scroll");
});

// jQuery('.bag_element').click(function () {
//   jQuery('body').addClass('open-newsletter-bag');
// });

// jQuery("#add-to-bag").click(function () {
//  setTimeout(function() {
//   jQuery("body").addClass("open-newsletter-bag");
// }, 5000);
// });

// jQuery(".close-newsletter").click(function () {
//   jQuery("body").removeClass("open-newsletter-bag");
// });

// For open the bag on add to cart button
jQuery(".nav-link.modal-btn.bag_element").click(function () {
  jQuery("body").addClass("open-newsletter-bag");
});

jQuery(".bag_element").click(function () {
  jQuery("body").css("overflow", "scroll");
});

// size modal
jQuery(".size-modal").click(function () {
  jQuery("body").addClass("open-size-bag");
});

jQuery(".close-guide").click(function () {
  jQuery("body").removeClass("open-size-bag");
});

jQuery(".overlay-newsletter ").click(function () {
  jQuery("body").removeClass("open-size-bag");
});

jQuery(".close-newsletter ").click(function () {
  jQuery("body").removeClass("open-newsletter");
});

jQuery(".overlay-newsletter").click(function () {
  jQuery("body").removeClass("open-newsletter");
});
jQuery(".line_element").click(function () {
  jQuery("body").addClass("open-newsletter");
});

// closed mini bag on add to cart
// jQuery("#add-to-bag").on("click", function () {
//   jQuery(".filter-sec.bag-sec-sec").show();
//   jQuery(".overlay-newsletter").hide();
// });

// jQuery("#add-to-bag").on("click", function () {
//   jQuery(".filter-sec.bag-sec-sec").hide();
//   jQuery(".overlay-newsletter").hide();
// });
jQuery(".nav-item .bag_element").on("click", function () {
  jQuery(".filter-sec.bag-sec-sec").show();
  jQuery(".overlay-newsletter").show();
  jQuery("body").css("overflow", "hidden");
});

//  Stop the Add to cart for select the Size option

document.addEventListener("DOMContentLoaded", function () {
  // Remove default checked radio for Size
  const sizeRadios = document.querySelectorAll(
    'fieldset[data-handle="Size"] input[type="radio"]'
  );
  sizeRadios.forEach(radio => (radio.checked = false));

  // Target elements inside .size-error
  const errorWrapper = document.querySelector(".size-error");
  const errorMessage = document.querySelector(".size-error .message");
  const errorText = document.querySelector(".size-error .error-text");

  if (errorWrapper && errorMessage && errorText) {
    errorWrapper.style.display = "none";
    errorMessage.style.display = "none";
    errorText.textContent = "";
  }

  // Hide error message when user selects a size
  sizeRadios.forEach(radio => {
    radio.addEventListener("change", function () {
      if (errorWrapper && errorMessage && errorText) {
        errorWrapper.style.display = "none";
        errorMessage.style.display = "none";
        errorText.textContent = "";
      }
    });
  });

  // Handle Add to Cart click
  jQuery(".add-to-bag")
    .off("click")
    .on("click", function (e) {
      e.preventDefault();

      const selectedSize = document.querySelector(
        'fieldset[data-handle="Size"] input[type="radio"]:checked'
      );

      if (!selectedSize) {
        if (errorWrapper && errorMessage && errorText) {
          errorWrapper.style.display = "block";
          errorMessage.style.display = "block"; 
          errorText.textContent = "Please select the size";
        }
        return false;
      }

      // Proceed with Add to Cart
      const form = document.querySelector("form[action='/cart/add']");
      const formData = new FormData(form);
    //for btn text 27 oct
      const $button = jQuery(this); // current button reference
    const originalText = $button.text(); // store original button text
    $button.text("Adding...").prop("disabled", true);
    //enb btn text

      fetch("/cart/add.js", {
        method: "POST",
        body: formData,
        headers: {
          "X-Requested-With": "XMLHttpRequest",
          Accept: "application/json",
        },
      })
        .then(response => response.json())
        .then(data => {
          console.log("Added to cart:", data);

          // Run your custom AJAX drawer update
          setTimeout(function () {
            var request = new XMLHttpRequest();
            var postcarturl = Shopify.routes.root + "cart?view=alternate";
            request.open("GET", postcarturl);

            request.onreadystatechange = function () {
              if (this.readyState === 4 && this.status === 200) {
                document.querySelector("#drawer_cart_items").innerHTML =
                  this.responseText;

                var count = jQuery("#cart-count").text();
                if (count > 0) {
                  jQuery("#image-fill").show();
                  jQuery("#image-unfill").hide();
                  jQuery("body").addClass("open-newsletter-bag");
                  jQuery(".accordion-panel-new").show();
                  jQuery("#bag-counter-container").css("display", "inline-block");
                  jQuery(".bag-counter").text(count);
                  jQuery(".content-add").show();
                }

                if (typeof removeCartItemBind === "function") {
                  removeCartItemBind();
                }
              }
              $button.text("Add to cart").prop("disabled", false); // 27 oct
            };
            request.send();
          }, 650);
        })
        .catch(error => console.error("Error:", error));
    });
});





// var count = $("#cart-count").text();
// if (count > 0) {
//   $("#bag-counter-container").css("display", "inline-block");
//   $(".bag-counter").text(count);
// }
// jQuery(".add-to-bag").click(function () {
//   setTimeout(function () {
//     var request = new XMLHttpRequest();

//     // Instantiating the request object
//     var postcarturl = Shopify.routes.root + "cart?view=alternate";
//     request.open("GET", postcarturl);
//     console.log(postcarturl, "removed");
//     // request.open("GET", "/cart?view=alternate");

//     // Defining event listener for readystatechange event
//     request.onreadystatechange = function () {
//       // Check if the request is compete and was successful
//       if (this.readyState === 4 && this.status === 200) {
//         // Inserting the response from server into an HTML element
//         // console.log(this.responseText);
//         document.querySelector("#drawer_cart_items").innerHTML =
//           this.responseText;

//         count = $("#cart-count").text();

//         if (count > 0) {
//           jQuery("#image-fill").show();
//           jQuery("#image-unfill").hide();
//           console.log("add");
//           jQuery("body").addClass("open-newsletter-bag");
//           $(".accordion-panel-new").show();
//           $("mobile-right-new").add;
//           $("#bag-counter-container").css("display", "inline-block");
//           $(".bag-counter").text(count);
//           $(".content-add").show();
//         }
//         // bind code for remove event
//         removeCartItemBind();
//         // end of the binding code
//       }
//     };

//     // Sending the request to the server
//     request.send();
//   }, 1000);
// });

jQuery(".close-newsletter").click(function () {
  jQuery("body").removeClass("open-newsletter-bag");
});

jQuery(".overlay-newsletter").click(function () {
  jQuery("body").removeClass("open-newsletter-bag");
});

jQuery(".overlay-newsletter").click(function () {
  jQuery("body").removeClass("open-newsletter");
  jQuery("body").css("overflow", "scroll");
});

jQuery(".colors-modal").click(function () {
  jQuery("body").addClass("open-color-bag");
});

jQuery(".close-newsletter ").click(function () {
  jQuery("body").removeClass("open-color-bag");
});

jQuery(".overlay-newsletter ").click(function () {
  jQuery("body").removeClass("open-color-bag");
});

jQuery(".close-btn-filter").click(function () {
  jQuery("body").removeClass("open-newsletter-filter");
});

jQuery(".mobile-facets__clear").click(function () {
  jQuery("body").removeClass("open-newsletter-filter");
});

jQuery(".mobile-facets__clear").click(function () {
  jQuery("body").removeClass("overflow-hidden-mobile");
});

jQuery(".close-btn-filter").click(function () {
  jQuery("body").removeClass("overflow-hidden-mobile");
});

// jQuery('.close-btn-filter').click(function () {
//   jQuery('mobile-facets__disclosure').removeClass('menu-opening');
// });

// jQuery('.mobile-facets__clear').click(function () {
//   jQuery('details').removeClass('menu-opening');
// });

jQuery(".button-apply").click(function () {
  jQuery("body").removeClass("open-newsletter-filter");
});

// jQuery('.overlay-newsletter').click(function () {
//   jQuery('body').removeClass('overflow-hidden-mobile open-newsletter-filter');
// });

// jQuery('.close-btn-filter ').click(function () {
//   jQuery('body').removeClass('open-newsletter');
// });

jQuery(".home-slider").click(function () {
  jQuery("body").addClass("open-slider-box");
});

jQuery(".close-slide").click(function () {
  jQuery("body").removeClass("open-slider-box");
  jQuery;
});

jQuery(".close-newsletter").click(function () {
  jQuery(".mobile-facets__disclosure").removeClass("menu-opening");
  jQuery(".mobile-facets__disclosure").removeAttr("open");
});

var swiper = new Swiper(".mySwiper", {
  // speed: 65,
  // autoplay: {
  //   disableOnInteraction: false,
  // },
  effect: "creative",
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
    renderBullet: function (index, className) {
      return '<span class="' + className + '"> 0' + (index + 1) + "</span>";
    },
  },
});

// jQuery(".img-fluid").click(function () {
//   console.log("inside mobile class");
//   jQuery(".home-slider").addClass("mobile-zoom");
//   destroyHomeSlider();
//   console.log("mobile-zoom1234");
// });

jQuery(".img-slide-box").click(function () {
  //  console.log("inside mobile class img-slide-box");
  jQuery(".home-slider").addClass("mobile-zoom");
  destroyHomeSlider();
  //  console.log("mobile-zoom1234");
});

jQuery(".close-slide").click(function () {
  jQuery("body").removeClass("mobile-zoom");
  showHomeSlider();
  var activeSlider = document.querySelector(".swiper-slide-active");
  // console.log(activeSlider);
  var id = activeSlider.getAttribute("key");
  var slider1 = jQuery(".swiper-pagination .swiper-pagination-bullet");
  jQuery.each(slider1, function (i) {
    // jQuery(this).click();
    if (id < 10) {
      var str = id;
      var n = str.slice(1);
      // console.log(n);
      $(".home-slider").trigger("to.owl.carousel", [n - 1, 0]);
      // console.log(id);
    } else {
      $(".home-slider").trigger("to.owl.carousel", [id - 1, 0]);
    }
  });
});

// jQuery("#zoom-close").click(function () {
//   jQuery("body").removeClass("mobile-zoom");
//   showHomeSlider();
// });

var $mobileZoom = $(".mobile-zoom");

var $homeSlider = $(".home-slider");

$(window).resize(function () {
  showHomeSlider();
});

function showHomeSlider() {
  if ($homeSlider.data("owlCarousel") !== "undefined") {
    if (window.matchMedia("(max-width: 1280px)").matches) {
      console.log($mobileZoom.length);
      if ($mobileZoom.length > 0) {
        // console.log($mobileZoom.length);
        // console.log("mobile-zoom in lop");
      } else {
        initialHomeSlider();
      }
    } else {
      destroyHomeSlider();
    }
  }
}
showHomeSlider();

function initialHomeSlider() {
  let hmslide = $homeSlider.addClass("owl-carousel").owlCarousel({
    items: 1,
    loop: true,
    autoplay: false,
    autoplayTimeout: 3000,
    smartSpeed: 500,
  });
}

function destroyHomeSlider() {
  $homeSlider.trigger("destroy.owl.carousel").removeClass("owl-carousel");
  // console.log("destroy");
}

// var color_value;
// color_value = $(".color-input-field input[type='radio']:checked").val();
// $("#color-value").text("Colour: " + color_value);

$(".color-box.text-center label").click(function (e) {
  jQuery("body").removeClass("open-color-bag");
  $(this).parent().find("input[type=radio]").prop("checked", true);
  color_value = $(this)
    .parent()
    .find("input[type=radio]")
    .filter(":checked")
    .val();
  console.log(color_value);

  let colorV = color_value;
  if (colorV.indexOf("-") > -1) {
    colorV = colorV.split("-")[1].trim().toLowerCase();
  } else {
    // colorV = colorV.trim().toLowerCase();
    colorV = colorV
      .trim()
      .toLowerCase()
      .replace(/\//g, "")
      .trim()
      .replace(/\s/g, "-")
      .replace(/--/g, "-");
  }
  if (window.matchMedia("(max-width: 1280px)").matches) {
    // $(".home-slider").trigger('to.owl.carousel',$(".home-slider .owl-item:not(.cloned) .item."+colorV).data('index')-1);
    $(".home-slider").hide();
    $(".home-slider." + colorV).show();

    $(".swiper.home-slider." + colorV).css("display", "flex");
  } else {
    if ($(".home-slider." + colorV).length > 0) {
      $(".home-slider").hide();
      $(".home-slider." + colorV).show();

      $(".swiper.home-slider." + colorV).css("display", "flex");
    }
  }

  $("#color-value").text("Colour: " + color_value);
});

$(".color-box.text-center img").click(function (e) {
  $("body").removeClass("open-color-bag");
  $(this).parent().find("input[type=radio]").prop("checked", true);
  $(this).parent().find("label").trigger("click");
});

// setTimeout(function(){
jQuery(".cart-remove-btn").click(function (event) {
  console.log("removed");
  event.preventDefault();
  var url = jQuery(this).attr("href");
  console.log(url);

  var request = new XMLHttpRequest();

  // Instantiating the request object
  request.open("POST", url);
  // Defining event listener for readystatechange event
  request.onreadystatechange = function () {
    var request1 = new XMLHttpRequest();

    // Instantiating the request object
    var postcarturl = Shopify.routes.root + "cart?view=alternate";
    request1.open("GET", postcarturl);
    console.log(postcarturl, "removed");
    //request1.open("GET", "/cart?view=alternate");

    // Defining event listener for readystatechange event
    request1.onreadystatechange = function () {
      // Check if the request is compete and was successful
      if (this.readyState === 4 && this.status === 200) {
        // Inserting the response from server into an HTML element
        // console.log("inner response"+this.responseText);
        document.querySelector("#drawer_cart_items").innerHTML =
          this.responseText;
        count = $("#cart-count").text();
        // console.log("count", count);
        if (count > 0) {
          // console.log("number", count);
          $("#bag-counter-container").css("display", "inline-block");
          $(".bag-counter").text(count);
          $("#image-fill").show();
          $("#image-unfill").hide();
          $(".content-add").show();
        } else {
          $("#bag-counter-container").css("display", "none");
          $(".accordion-panel-new").hide();
          $("#image-unfill").show();
          $("#image-fill").hide();
          $("#image-unfill sup").html(0);
          $(".content-add").hide();
        }
        // bind code for remove event
        removeCartItemBind();
        // end of the binding code
      }
    };

    // Sending the request to the server
    request1.send();

    // Check if the request is compete and was successful
    if (this.readyState === 4 && this.status === 200) {
      // console.log('here');
    }
  };

  // Sending the request to the server
  request.send();
});
// }, 5000);

// bind function for remove cart item event

var removeCartItemBind = function () {
  jQuery(".cart-remove-btn").click(function (event) {
    console.log("remove function");
    event.preventDefault();
    var url = jQuery(this).attr("href");
    console.log(url);

    var request = new XMLHttpRequest();

    // Instantiating the request object
    request.open("POST", url);
    // Defining event listener for readystatechange event
    request.onreadystatechange = function () {
      var request1 = new XMLHttpRequest();

      // Instantiating the request object
      var postcarturl = Shopify.routes.root + "cart?view=alternate";
      request1.open("GET", postcarturl);
      console.log(postcarturl, "removed");
      //  request1.open("GET", "/cart?view=alternate");

      // Defining event listener for readystatechange event
      request1.onreadystatechange = function () {
        // Check if the request is compete and was successful
        if (this.readyState === 4 && this.status === 200) {
          // Inserting the response from server into an HTML element
          // console.log("inner response"+this.responseText);
          document.querySelector("#drawer_cart_items").innerHTML =
            this.responseText;
          count = $("#cart-count").text();
          // console.log("count" + count);
          if (count > 0) {
            // console.log("number" + count);
            $("#bag-counter-container").css("display", "inline-block");
            $(".bag-counter").text(count);
            $("#image-fill").show();
            $("#image-unfill").hide();
          } else {
            $("#bag-counter-container").css("display", "none");
            $(".accordion-panel-new").hide();
            $("#image-unfill").show();
            $("#image-fill").hide();
            $(".content-add").hide();
            $("#image-unfill sup").html(0);
          }
          removeCartItemBind();
        }
      };

      // Sending the request to the server
      request1.send();

      // Check if the request is compete and was successful
      if (this.readyState === 4 && this.status === 200) {
        // console.log('here');
      }
    };

    // Sending the request to the server
    request.send();
  });
};

// end of the binding function

// For header navigation

jQuery(document).ready(function () {
  if (jQuery(window).width() <= 1280) {
    jQuery("ul.navbar-nav>li>a ").after(
      "<span class='plus_img_inner'>plus</span>"
    );
    jQuery("span.plus_img_inner").click(function (e) {
      jQuery(this).toggleClass("open_inner_sub-menu ");
      jQuery(this).siblings(" ul.navbar-nav").slideToggle("slow");
      e.stopPropagation();
    });
  }
});

$(function () {
  $("ul.navbar-nav li:has(ul)").addClass("li-has-menu");
  $("ul.navbar-nav li:has(ul) ul").addClass("sub-menu");
});

jQuery(".toggle-item").click(function (e) {
  e.preventDefault();
  var $this = jQuery(this);
  if ($this.next().hasClass("show")) {
    $this.next().removeClass("show");
    $this.next().slideUp(350);
  } else {
    $this.parent().parent().find("li .inner").removeClass("show");
    $this.parent().parent().find("li .inner").slideUp(350);
    $this.next().toggleClass("show");
    $this.next().slideToggle(350);
  }
});

// Naviagtion Script
var isMobile = window.matchMedia("only screen and (max-width: 1280px)").matches;

if (isMobile) {
  var listItems = document.querySelectorAll(".navbar-nav.main li");
  var body = document.body;
  var main = $(".main");
  var menuOverlay = $(".menu-overlay");

  listItems.forEach(function (item) {
    item.addEventListener("click", function () {
      var result = document.getElementsByClassName(
        "nav-link-header active-nav"
      ).length;
      if (result) {
        body.classList.add("header-white");
      } else {
        body.classList.remove("header-white");
      }
    });
  });

  menuOverlay.click(function () {
    body.classList.remove("header-white");
    main.removeClass("active-nav");
  });
}

setTimeout(function () {
  if (window.matchMedia("(min-width: 1280px)").matches) {
    console.log("running");
    $(".nav-item.main.li-has-menu").hover(
      function (e) {
        $("body").addClass("active-hover-menu");
        console.log("loop hover");
      },
      function (e) {
        $("body").removeClass("active-hover-menu");
        console.log("loop out");
      }
    );
  }
}, 500);

// end navigation script

// $(".nav-link-header a.nav-link.main").click(function (e) {
//   $(".nav-link-header a.nav-link.main")
//     .not(this)
//     .parent()
//     .removeClass("active-nav");

//   $(this).parent().toggleClass("active-nav");
// });
// $(".nav1-head .nav1").click(function (e) {
//   $(".nav1-head").removeClass("active-nav1");
//   $(this).parent().toggleClass("active-nav1");
// });

// $(".nav2-head .nav1").click(function (e) {
//   $(".nav2-head").removeClass("active-nav2");
//   $(this).parent().toggleClass("active-nav2");
// });

// owl carousel
$(".owl-carousel.homepageBannerSlider").owlCarousel({
  items: 1,
  loop: true,
  margin: 10,
  autoplay: true,
  nav: false,
  slideSpeed: 3000,
  // singleItem: true,
  paginationSpeed: 3000,
  mouseDrag: false,
  touchDrag: false,
  // singleItem: true,
  animateIn: "fadeIn",
  animateOut: "fadeOut",
  autoHeight: true,
  dots: false,
});

var owl = $(".owl-carousel");
owl.owlCarousel();
owl.on("changed.owl.carousel", function (event) {
  setTimeout(function () {
    console.log(event, "=========Changed carousel");
    if ($(".owl-item.active .item").hasClass("dark")) {
      $("body").addClass("dark-header");
      console.log("ADDED Dark header ");
    } else {
      $("body").removeClass("dark-header");
      console.log("Remove header");
    }
  }, 100);
});

$(window).scroll(function () {
  if ($(this).scrollTop() > 0) {
    $("body").addClass("sticky");
    // $("body").removeClass("dark-header");
  } else {
    $("body").removeClass("sticky");
  }
});

// $(function () {
//   $(".nav-link").click(function () {
//     $("body").toggleClass("header-white");
//   });
// });
/**************remove script********************/
var listItems = document.querySelectorAll(".navbar-nav.main li");
listItems.forEach(function (item) {
  item.addEventListener("click", function () {
    var result = document.getElementsByClassName(
      "nav-link-header active-nav"
    ).length;
    if (result) {
      document.body.classList.add("header-white");
    } else {
      document.body.classList.remove("header-white");
    }
  });
});

/***********************************/

$(".menu-overlay").click(function () {
  $("body").removeClass("header-white");
});
$(".menu-overlay").click(function () {
  $(".main").removeClass("active-nav");
});

/***** LookBook Listing ******/

let a = lightGallery(document.getElementById("lightgallery"), {
  loop: false,
  speed: 500,
  //  mode: 'lg-fade',
  startZoom: false,
  // slideEndAnimatoin: false,
  closable: false,
  // enableDrag: false,
  // enableSwipe: false,
  // scale : 1,
});
